<template>
    <div class="download_page" @click.stop.prevent="toDownloadApp">
        <img src="@/assets/img/spread/page.png" alt="download">
    </div>
</template>
  
<script>
export default {
    name: "Spread",
    components: {},
    data() {
        return {
            downloadAppUrl: "http://a.app.qq.com/o/simple.jsp?pkgname=com.aigupiao.ui",
        };
    },
    created() {
        //
    },
    mounted() {
        //
    },
    methods: {
        // 跳转下载链接
        toDownloadApp() {
            location.href = this.downloadAppUrl;
        },
    },
};
</script>
  
<style scoped lang="scss">
.download_page {
    position: relative;
    padding: 0;
    min-height: 100vh;
    box-sizing: border-box;

    img {
        width: 100%;
        height: auto;
        display: block;;
    }
}
</style>